import wrapRootElement from './src/providers';

export {wrapRootElement};
